import { render } from "./ResetPasswordForm.vue?vue&type=template&id=03f31440"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js"

import "./ResetPasswordForm.vue?vue&type=style&index=0&id=03f31440&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__